import type { snapshotDeliveryCache } from "@/features/delivery/cache";
import type { FindDeliveryByIdQuery } from "@/libs/generated/operations";

export type Delivery = FindDeliveryByIdQuery["findDeliveryById"];

export type DeliveryMutationContext = {
  snapshot: ReturnType<typeof snapshotDeliveryCache>;
};

/** Form state uses datetime-local strings; publish schema coerces to Date on submit. */
export type PublishDeliveryFormValues = {
  id: number;
  carAvailabilityDate: string;
  carPickUpDate: string;
  carDeliveryDeadline: string;
  selectedDriverId: number | null;
  clientFinalPrice: number;
  minPrice: number;
  maxPrice: number;
  medianPrice: number;
  wantedPrice: number;
};

export const publishDeliveryFormDefaultValues: PublishDeliveryFormValues = {
  id: 0,
  carAvailabilityDate: "",
  carPickUpDate: "",
  carDeliveryDeadline: "",
  selectedDriverId: null,
  clientFinalPrice: 0,
  minPrice: 0,
  maxPrice: 0,
  medianPrice: 0,
  wantedPrice: 0,
};
